<template>
  <div class="ui container">12312313256</div>
</template>
<script>
export default {
  name: "solution",
}
</script>



// WEBPACK FOOTER //
// src/components/solution.vue